<template>
  <!-- eslint-disable -->
  <div class="floating-text">
    <div class="d-flex justify-space-between floating-text__header">
      <div class="floating-text__title">{{ $t("shortcodes.live_chat.floating_text_title") }}</div>
      <v-switch
        v-model="node.floatingText.enabled"
        color="primary"
        :ripple="false"
        hide-details
        inset></v-switch>
    </div>

    <v-expand-transition>
      <div v-if="node.floatingText.enabled" class="expandable-content">
        <div class="floating-text__section-label">{{ $t("shortcodes.live_chat.floating_text_content") }}</div>
        <div class="floating-text__field-label">{{ $t("shortcodes.live_chat.floating_text_message") }}</div>

        <v-btn v-if="!showEditor" class="d-flex mb-3" text outlined @click="showEditor = true">
          {{ $t("shortcodes.live_chat.floating_text_edit") }}
        </v-btn>

        <div v-if="!showEditor" class="mb-3">
          <div class="content-preview-label">{{ $t("shortcodes.live_chat.floating_text_preview_label") }}</div>
          <div class="text-left content-preview" v-html="node.floatingText.text"></div>
        </div>

        <va-tinymce-input
          v-if="showEditor"
          class="mb-3 w-full"
          :current-content="node.floatingText.text"
          :editor-height="140"
          text-only
          title=""
          :forced-root-block-attrs="{ class: 'live-chat-floating-text no-blog-styles' }"
          auto-resize
          @update="content => (node.floatingText.text = content)" />

        <v-select
          class="floating-text__animation panzoom-ignore"
          v-model="node.floatingText.animation"
          :items="FLOATING_TEXT_ANIMATIONS"
          :label="$t('shortcodes.live_chat.floating_text_animation')"
          hide-details
          attach
          :menu-props="{ offsetOverflow: true, offsetY: true }"></v-select>

        <div class="floating-text__divider"></div>

        <div class="floating-text__section-label">{{ $t("shortcodes.live_chat.floating_text_padding") }}</div>

        <div class="floating-text__padding-compass">
          <input
            class="floating-text__padding-input panzoom-ignore"
            type="number"
            v-model.number="node.floatingText.paddingLeft" />
          <div class="floating-text__padding-column">
            <input
              class="floating-text__padding-input panzoom-ignore"
              type="number"
              v-model.number="node.floatingText.paddingTop" />
            <div class="floating-text__padding-preview">
              <div class="floating-text__padding-preview-inner">
                {{ $t("shortcodes.live_chat.floating_text_preview_placeholder") }}
              </div>
            </div>
            <input
              class="floating-text__padding-input panzoom-ignore"
              type="number"
              v-model.number="node.floatingText.paddingBottom" />
          </div>
          <input
            class="floating-text__padding-input panzoom-ignore"
            type="number"
            v-model.number="node.floatingText.paddingRight" />
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
  import { FLOATING_TEXT, FLOATING_TEXT_ANIMATIONS } from "./constant";

  /* eslint-disable */
  export default {
    name: "LiveChatFloatingText",
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        FLOATING_TEXT_ANIMATIONS,
        showEditor: !this.node?.floatingText?.text,
      };
    },
    beforeMount() {
      if (!this.node.floatingText) {
        this.$set(this.node, "floatingText", { ...FLOATING_TEXT });
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .floating-text {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 16px;
    background-color: get-color("primary-10-hover");
    border-radius: 6px;
    padding: 12px;
    box-sizing: border-box;
    text-align: left;

    &__header {
      align-items: center;

      &::v-deep {
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }

    &__title {
      color: get-color("headline");
      @include text-body-2-bold();
    }

    &__section-label {
      color: get-color("subtitle");
      @include text-caption-bold();
      letter-spacing: 0.5px;
      margin-top: 12px;
      margin-bottom: 8px;
    }

    &__field-label {
      color: get-color("subtitle");
      @include text-caption-bold();
      margin-bottom: 6px;
    }

    &__animation {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 32px;
    }

    &__divider {
      height: 1px;
      width: 100%;
      background-color: get-color("border");
      margin: 12px 0;
    }

    &__padding-compass {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
    }

    &__padding-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      width: 200px;
    }

    &__padding-input {
      flex-shrink: 0;
      box-sizing: border-box;
      width: 44px;
      height: 32px;
      padding: 4px;
      background-color: get-color("white");
      border: 1px solid get-color("border");
      border-radius: 4px;
      text-align: center;
      color: get-color("subtitle");
      @include text-body-2();
      outline: none;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      -moz-appearance: textfield;

      &:focus {
        border-color: get-color("primary");
      }
    }

    &__padding-preview {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px dashed get-color("border");
      border-radius: 4px;
      padding: 24px 44px;
      box-sizing: border-box;
    }

    &__padding-preview-inner {
      background-color: get-color("white");
      padding: 14px 32px;
      border-radius: 4px;
      color: get-color("subtitle");
      @include text-button-small();
    }
  }
</style>
